module.exports = __webpack_public_path__ + "img/img_teacher4.0dcb65de.png";